import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/HeaderPremium";
import Footer from "./components/FooterPremium";
import WhatsAppButton from "./components/WhatsAppButton";
import StickyCallButton from "./components/StickyCallButton";
import MobileStickyBar from "./components/MobileStickyBar";
import Home from "./pages/HomePagePremium";
import CompanyProfile from "./pages/CompanyProfile";
import Products from "./pages/Products";
import Process from "./pages/Process";
import Projects from "./pages/Projects";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import AfterSalesService from "./pages/AfterSalesService";
import AMCServices from "./pages/AMCServices";
import Downloads from "./pages/Downloads";
import Careers from "./pages/Careers";
import ManufacturingFacility from "./pages/ManufacturingFacility";
import InstallationGalleryPage from "./pages/InstallationGalleryPage";
// Product Pages - Water Filling Machines
import WaterFilling30BPM from "./pages/products/WaterFilling30BPM";
import WaterFilling40BPM from "./pages/products/WaterFilling40BPM";
import WaterFilling60BPM from "./pages/products/WaterFilling60BPM";
import WaterFilling90BPM from "./pages/products/WaterFilling90BPM";
import WaterFilling120BPM from "./pages/products/WaterFilling120BPM";
import WaterFilling200BPM from "./pages/products/WaterFilling200BPM";
// Product Pages - RO Plants
import ROPlant2000LPH from "./pages/products/ROPlant2000LPH";
import ROPlant3000LPH from "./pages/products/ROPlant3000LPH";
import ROPlant4000LPH from "./pages/products/ROPlant4000LPH";
import ROPlant5000LPH from "./pages/products/ROPlant5000LPH";
import ROPlant10000LPH from "./pages/products/ROPlant10000LPH";
// Product Pages - Auxiliary Machines
import PETBottleBlowing from "./pages/products/PETBottleBlowing";
import StickerLabelling from "./pages/products/StickerLabelling";
import ShrinkPackaging from "./pages/products/ShrinkPackaging";
// SEO Pages
import WaterPlant20BPM from "./pages/seo/WaterPlant20BPM";
import WaterPlant24BPM from "./pages/seo/WaterPlant24BPM";
import WaterPlant30BPM from "./pages/seo/WaterPlant30BPM";
import WaterPlant40BPM from "./pages/seo/WaterPlant40BPM";
import WaterPlant60BPM from "./pages/seo/WaterPlant60BPM";
import WaterPlant90BPM from "./pages/seo/WaterPlant90BPM";
import WaterPlant120BPM from "./pages/seo/WaterPlant120BPM";
import WaterPlant200BPM from "./pages/seo/WaterPlant200BPM";
import WaterFillingMachine from "./pages/seo/WaterFillingMachine";
import HowToStartWaterBusiness from "./pages/seo/HowToStartWaterBusiness";
// Policy Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import NotFound from "./pages/NotFound";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import SolutionCategoryPage from "./pages/SolutionCategoryPage";
import ProductBySlug from "./pages/ProductBySlug";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company-profile" element={<CompanyProfile />} />
          <Route path="/products" element={<Products />} />
          <Route path="/process" element={<Process />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          {/* Company Pages */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/after-sales-service" element={<AfterSalesService />} />
          <Route path="/amc-services" element={<AMCServices />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/manufacturing-facility" element={<ManufacturingFacility />} />
          <Route path="/installation-gallery" element={<InstallationGalleryPage />} />
          {/* Product Pages - Water Filling Machines */}
          <Route path="/products/30-bpm-water-filling-machine" element={<WaterFilling30BPM />} />
          <Route path="/products/40-bpm-water-filling-machine" element={<WaterFilling40BPM />} />
          <Route path="/products/60-bpm-water-filling-machine" element={<WaterFilling60BPM />} />
          <Route path="/products/90-bpm-water-filling-machine" element={<WaterFilling90BPM />} />
          <Route path="/products/120-bpm-water-filling-machine" element={<WaterFilling120BPM />} />
          <Route path="/products/200-bpm-water-filling-machine" element={<WaterFilling200BPM />} />
          {/* Product Pages - RO Plants */}
          <Route path="/products/2000-lph-ro-plant" element={<ROPlant2000LPH />} />
          <Route path="/products/3000-lph-ro-plant" element={<ROPlant3000LPH />} />
          <Route path="/products/4000-lph-ro-plant" element={<ROPlant4000LPH />} />
          <Route path="/products/5000-lph-ro-plant" element={<ROPlant5000LPH />} />
          <Route path="/products/10000-lph-ro-plant" element={<ROPlant10000LPH />} />
          {/* Product Pages - Auxiliary Machines */}
          <Route path="/products/pet-bottle-blowing-machine" element={<PETBottleBlowing />} />
          <Route path="/products/sticker-labelling-machine" element={<StickerLabelling />} />
          <Route path="/products/shrink-packaging-machine" element={<ShrinkPackaging />} />
          {/* SEO Landing Pages */}
          <Route path="/20-bpm-water-plant" element={<WaterPlant20BPM />} />
          <Route path="/24-bpm-water-plant" element={<WaterPlant24BPM />} />
          <Route path="/30-bpm-water-plant" element={<WaterPlant30BPM />} />
          <Route path="/40-bpm-water-plant" element={<WaterPlant40BPM />} />
          <Route path="/60-bpm-water-plant" element={<WaterPlant60BPM />} />
          <Route path="/90-bpm-water-plant" element={<WaterPlant90BPM />} />
          <Route path="/120-bpm-water-plant" element={<WaterPlant120BPM />} />
          <Route path="/200-bpm-water-plant" element={<WaterPlant200BPM />} />
          <Route path="/water-filling-machine" element={<WaterFillingMachine />} />
          <Route path="/how-to-start-mineral-water-business" element={<HowToStartWaterBusiness />} />
          {/* Blog / Knowledge Hub */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {/* Solutions & dynamic product pages */}
          <Route path="/solutions/:slug" element={<SolutionCategoryPage />} />
          <Route path="/products/:slug" element={<ProductBySlug />} />
          {/* Policy Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <StickyCallButton />
        <MobileStickyBar />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
